import React, { useState, useCallback, useRef, useEffect } from 'react';
import Cleave from 'cleave.js/react';
import Dropzone from 'react-dropzone';
import ReactModal from 'react-modal';
import FilePreview from 'react-preview-file';

import AuthService from '../../../../services/auth-service';
import SolicitacaoService from '../../../../services/solicitacao-service';
import trash from '../autorizacaoGuias/images/trash.png'

import errorImg from './images/archive.png';
import successImg from './images/success.png';
import uploadImg from './images/upload.png';
/* eslint-disable */
export default (props) => {
    const wrapperRef = useRef(null);
    const [loadingAuth, setLoadingAuth] = useState(false);
    const [loadingForm, setLoadingForm] = useState(false);
    const [didError, setDidError] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [response, setResponse] = useState({});
    const [errorsForm, setErrorsForm] = useState([]);
    const [showInfo, setShowInfo] = useState(false);
    const [carteira, setCarteira] = useState("");
    const [carteiraRaw, setCarteiraRaw] = useState("");
    const [nascimento, setNascimento] = useState("");
    const [nome, setNome] = useState("");
    const [telefone1, setTelefone1] = useState("");
    const [telefone2, setTelefone2] = useState("");
    const [tipaut, setTipaut] = useState("")
    const [dataRealizacao, setDataRealizacao] = useState("");
    const [local, setLocal] = useState("");
    const [email, setEmail] = useState("");
    const [emailConf, setEmailConf] = useState("");
    const [files, setFiles] = useState([]);

    const [cpf, setCpf] = useState("");
    const [sexo, setSexo] = useState("");
    const [authFailed, setAuthFailed] = useState(false);

    const [fileUrl, setFileUrl] = useState("");
    const [selectedFile, setSelectedFile] = useState("");
    const [protocolo, setProtocolo] = useState("");
    const [, updateState] = React.useState();
    const forceUpdate = useCallback(() => updateState({}), []);

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, false);
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };
    }, []);


    const handleClickOutside = event => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setShowInfo(false);
        }
    };

    const handleCarteiraChange = e => {
        setCarteira(e.target.value);
        setCarteiraRaw(e.target.rawValue);
    };

    const autenticar = async () => {
        if (validadeAuthForm()) {
            return;
        }
        setResponse({});
        if (carteiraRaw.substr(0, 4) !== '0055') {
            const chaveUnica = await AuthService.getMatriculaVida(carteiraRaw);
            
            if(chaveUnica.status === false){
                setAuthFailed(true);
            }
            setResponse({ status: true });
            return;
        }
        setLoadingAuth(true);
        const res = await AuthService.auth(carteiraRaw, nascimento);
        setLoadingAuth(false);
        const errors = [];
        if (res.status) {
            setResponse(res);
        }
        if (res.info === "Falha na autenticacao") {
            errors.push({ field: "login", message: "Beneficiário não encontrado" });
        }
        if (res.info === "Dados enviados incompletos.") {
            errors.push({ field: "login", message: "Verifique os dados inseridos" });
        }
        if (res.error) {
            setDidError(true);
        }
        setErrorsForm(errors);
    };

    const onSendForm = async () => {
        setProtocolo("");
        const errors = [];

        if (validateSendForm()) {
            return;
        }
        setLoadingForm(true);
        //VERIFICA SE TEM MATVIDA
        let chaveUnica = await AuthService.getMatriculaVida(carteiraRaw);
        let res

        if (chaveUnica.status === false) {
            // Caso não exista a "vida", criar no sistema Protheus
            const createVida = await AuthService.createIntercambioProtheus(carteiraRaw, nome, nascimento, cpf, sexo);

            if (!createVida) {
                setDidError(true);
                setLoadingForm(false);
                return;
            }

            // Após criar a vida no sistema Protheus, buscar novamente a chaveUnica antes de prosseguir
            chaveUnica = await AuthService.getMatriculaVida(carteiraRaw);
            if (chaveUnica.status === false) {
                setDidError(true);                      
                setLoadingForm(false);
                return;
            }

            // Cria ocorrência na MOSIA com os dados corretos
            res = await SolicitacaoService.sendMosia(
                carteiraRaw, 
                nome ? nome : response.nomeBeneficiario, 
                telefone1, 
                telefone2, 
                local, 
                email, 
                chaveUnica.chaveUnica,
                tipaut
            );
        } else {
            res = await SolicitacaoService.sendMosia(carteiraRaw, nome ? nome : response.nomeBeneficiario, telefone1, telefone2, local, email, chaveUnica.chaveUnica, tipaut);

        }

        if (res.status) {

            const lerArquivoComoBase64 = (file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onloadend = () => {
                        resolve(reader.result);
                    };
                    reader.onerror = reject;
                });
            };

            const enviarAnexos = files.map(async (file) => {

                if (file.size <= 600 * 1024) {
                    const fileUrlBase64 = await lerArquivoComoBase64(file);
                    if (chaveUnica.status === false) {
                        return SolicitacaoService.sendAnexo(res.data.protocolo, fileUrlBase64, carteiraRaw);
                    } else {
                        return SolicitacaoService.sendAnexo(res.data.protocolo, fileUrlBase64, chaveUnica.chaveUnica);
                    }
                } else {
                    
                    const linkDoc = await SolicitacaoService.senMinio(file, carteiraRaw);
                    if (linkDoc.status) {
                        if (chaveUnica.status === false) {
                            await SolicitacaoService.sendAnexo(res.data.protocolo, '', carteiraRaw, linkDoc.fileUrl);
                        } else {
                            await SolicitacaoService.sendAnexo(res.data.protocolo, '', chaveUnica.chaveUnica, linkDoc.fileUrl);
                        }

                    } else {
                        setDidError(true);
                    }
                }

            });

            // Aguarda todos os uploads de arquivos serem concluídos
            const resultadosAnexos = await Promise.all(enviarAnexos);
            setLoadingForm(false);

            setProtocolo(res.data.protocolo);
        } else {
            if (res.error) {
                setDidError(true);
            } else {
                const errors = [];
                errors.push({ field: "solicitacao", message: "Verifique os dados inseridos" });
            }
        }
    };

    const onRemoveFile = (index, name) => {
        let newFiles = files;
        newFiles = files.filter((file, fIndex) => {
            return file.name !== name && fIndex !== index;
        });
        setFiles(newFiles);
        forceUpdate();
    };

    const validadeAuthForm = () => {
        const errors = [];
        if (carteiraRaw.length === 0) {
            errors.push({ field: 'carteira', message: 'Preencha sua carteira' });
        } else {
            if (carteiraRaw.length !== 17) {
                errors.push({ field: "carteira", message: "Verifique sua carteira, ela deve conter 17 dígitos" });
            }
        }
        if (nascimento.length !== 10) {
            errors.push({ field: "nascimento", message: "Verifique sua data de nascimento" });
        }
        setErrorsForm(errors);
        return errors.length;
    };

    const validateSendForm = () => {
        const errors = [];
        if (nome.length === 0 && !!!response.nomeBeneficiario) {
            errors.push({ field: 'nome', message: 'Preencha seu nome' });
        }
        if (!!!telefone1.length && !!!telefone2.length) {
            errors.push({ field: 'telefone', message: 'Preencha pelo menos um telefone' });
        }
        if (local.length === 0) {
            errors.push({ field: 'local', message: 'Preencha o local' });
        }
        if (email.length === 0) {
            errors.push({ field: 'email', message: 'Preencha seu email' });
        }
        if (email !== emailConf) {
            errors.push({ field: 'emailConf', message: 'Os campos estão iguais' });
        }
        if (files.length === 0) {
            errors.push({ field: 'files', message: 'Envie pelo menos uma guia' });
        }
        if (tipaut.length === 0) {
            errors.push({ field: 'tipaut', message: 'Selecione uma opção' });
        }
        if (files.length > 0) {
            var error = 0;
            const regex = /^([a-zA-Zà-úÀ-Ú0-9]|-|_|\s)+$/;
            var extPermitidas = ['JPEG', 'jpeg', 'jepg', 'JEPG', 'jpg', 'JPG', 'png', 'PNG', 'pdf', 'PDF', 'doc', 'DOC', 'docx', 'DOCX'];
            var qtdFiles = files.length;
            var nameFile = '';
            var errorExt;

            for (var i = 0; i < qtdFiles; i++) {
                if (!regex.test(files[i].name.split('.')[0])) {
                    nameFile = nameFile + files[i].name + ' ';
                    error++;
                }
                if (typeof extPermitidas.find(function (ext) { return files[i].name.split('.').pop() === ext; }) === 'undefined') {
                    errorExt = true;
                    error++;
                }
            }
            if (error > 0) {
                if (errorExt) {
                    errors.push({ field: 'files', message: 'Tipo de arquivo não aceito.' });
                } else {
                    errors.push({ field: 'files', message: 'Anexo (' + nameFile + ') incorreto. Favor remova os caracteres especiais do nome do arquivo e tente novamente.' });
                }
            }
        }
        setErrorsForm(errors);
        return errors.length;
    };

    const renderValidation = (field) => {
        const error = errorsForm.filter(e => e.field === field);
        if (!error.length) {
            return null;
        }
        return (<div className="validation-message">{error[0].message}</div>);
    };

    const renderFiles = () => {
        return (
            files.map((e, index) => {
                return (
                    <div key={index} className="file" onClick={() => { if (e.type.match(/image.*/)) { setSelectedFile(e); setIsModalOpen(true); } }}>
                        <img
                            onClick={(ev) => { ev.stopPropagation(); onRemoveFile(index, e.name); }}
                            src={trash}
                            alt='excluir' />
                        {/* <i onClick={(ev) => { ev.stopPropagation(); onRemoveFile(index, e.name); }} className="fa fa-times-circle icon-file"></i>  */}
                        {e.name}
                    </div>
                );
            })
        );
    };

    const renderImagePreview = () => {
        return (
            <ReactModal isOpen={isModalOpen} shouldCloseOnEsc shouldCloseOnOverlayClick onRequestClose={() => { setSelectedFile(""); setIsModalOpen(false); }}>
                {selectedFile ?
                    <FilePreview file={selectedFile}>
                        {(preview) => <img src={preview} alt="preview" />}
                    </FilePreview>
                    : null
                }
            </ReactModal>
        );
    };

    const renderUpload = () => {
        return (
            <Dropzone onDrop={acceptedFiles => onDrop(acceptedFiles)}>
                {({ getRootProps, getInputProps, isDragActive }) => (
                    <section>
                        <div className={isDragActive ? "activeDrop uploadZone" : "uploadZone"} {...getRootProps()}>
                            <input {...getInputProps()} />
                            <img src={uploadImg} alt="upload" style={{ width: "20%", maxWidth: "115px" }} />
                            {isDragActive ?
                                <p>Solte os para enviar os arquivos</p> :
                                <p>Anexar pedido médico: arraste ou clique para adicionar</p>
                            }
                        </div>
                    </section>
                )}
            </Dropzone>
        );
    };

    const renderWarning = () => {
        if (carteiraRaw.length < 4) {
            return null;
        }
        return carteiraRaw.substr(0, 4) === '0055' ?
            (<div className="txt-vermelho padv-1">
                Atenção, informe caso o procedimento seja realizado <span className="highligth">fora</span> do Vale dos Sinos
            </div>)
            :
            (<div className="txt-vermelho padv-1">
                Atenção: a autorização será válida para realização no Vale dos Sinos
            </div>);
    };

    const renderSuccess = () => {
        if (!!!protocolo) {
            return null;
        }
        return (
            <div className="success">
                <img src={successImg} alt="Sucesso" />
                <p>Solicitação enviada com sucesso! Protocolo: <span>{protocolo}</span></p>

                <div>
                    O retorno será enviado para o e-mail informado.<br />
                    O prazo de retorno da sua solicitação será de:<br />

                    <div className="txt-vermelho padv-1">
                        Procedimentos ambulatorial e Terapias- até 10 dias úteis. <br />
                        Atendimento em regime de internação e procedimentos de alta complexidade (PAC) – até 21 dias úteis.
                    </div>
                    <div className="text--highligth">
                        A autorização terá validade de <span>60 dias</span>.
                    </div>

                </div>
                <div>
                    Cliente Unimed Vale do Sinos: você também pode acompanhar sua solicitação pelo App.
                </div>
            </div>
        );
    };

    const renderError = () => {
        if (didError) {
            return (
                <div className="not-found-wrapper">
                    <img src={errorImg} alt="Erro" />
                    <h5>Ocorreu um erro</h5>
                    <p>
                        Um erro ocorreu ao processar sua consulta. Por favor tente
                        novamente.
                    </p>
                    <p>
                        Se esta mensagem for recorrente, entre em contato com o suporte.
                    </p>
                </div>
            );
        }
        return null;
    };

    const onDrop = (receivedFiles) => {
        setFiles(prevFiles => prevFiles.concat(receivedFiles));
        forceUpdate();

        const file = receivedFiles[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
       
    };

    return (
        <section className={`autorizacao txt8 lh-1 ${props.hide ? 'hide' : ''}`}>
            <h2 className="txt-laranja ">Autorização de guias</h2>
            <div className="autorizacao-passos">
                <div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <h3 className="txt-verde">Passo 1 - Identificação</h3>
                        <button className="btn btn--icon" onClick={() => setShowInfo(!showInfo)} ref={wrapperRef}><i className="fa fa-info-circle"></i><span>PRAZOS</span></button>
                    </div>
                    <div className={showInfo ? "info" : "info heightless"}>
                        O prazo de retorno da sua solicitação será de:<br />
                        <div className="txt-vermelho padv-1">
                            Procedimentos ambulatorial e Terapias- até 10 dias úteis. <br />
                            Atendimento em regime de internação e procedimentos de alta complexidade (PAC) – até 21 dias úteis.
                        </div>
                        A autorização terá validade de 60 dias.
                    </div>
                    <div className="box-passos">
                        <div className="linha-form--small">
                            <span >Número da carteira <span className="txt-vermelho">*</span></span>
                            <Cleave type={'ontouchstart' in document.documentElement ? "tel" : "text"} id="carteira" name="carteira" value={carteira} options={{ blocks: [1, 3, 12, 1], delimiter: ' ', numericOnly: true }} onChange={handleCarteiraChange} />
                            {renderValidation("carteira")}
                        </div>
                        <div className="linha-form--small">
                            <span>Data de nascimento <span className="txt-vermelho">*</span></span>
                            <Cleave type={'ontouchstart' in document.documentElement ? "tel" : "text"} options={{ date: true, datePattern: ['d', 'm', 'Y'] }} onChange={e => setNascimento(e.target.value)} />
                            <button className="btn" onClick={() => autenticar()}>Próximo passo</button>
                            {renderValidation("nascimento")}
                        </div>
                        {renderError()}
                        {loadingAuth ?
                            <div className="lds-ring"><div></div><div></div><div></div><div></div></div> : null}
                        {renderValidation("login")}
                    </div>
                    {renderWarning()}
                </div>
                <div className={`txt8 lh-1 ${response.status ? 'autorizacao' : 'autorizacao hide'}`}>
                    <h3>Passo 2 - Informações</h3>
                    <div id="container-ms-SolicitarAutorizacao-9004"></div> 
                    <div className="box-passos">
                    {authFailed && (
                        <div>
                            <div className="linha-form">
                            <div>CPF:<span className="txt-vermelho">*</span></div>
                            <div>
                                <Cleave
                                value={cpf}
                                onChange={(e) => setCpf(e.target.value)}
                                options={{
                                    delimiters: ['.', '.', '-'],
                                    blocks: [3, 3, 3, 2],
                                    numericOnly: true
                                }}
                                />
                            </div>
                            {renderValidation("cpf")}
                            </div>
                            <div className="linha-form">
                                <div>
                                    Sexo:
                                    <span className="txt-vermelho">*</span>
                                    </div>
                                    <div>
                                    <select
                                    value={sexo}
                                    onChange={(e) => setSexo(e.target.value)}
                                    >
                                    <option value="">Selecione</option>
                                    <option value="M">Masculino</option>
                                    <option value="F">Feminino</option>
                                    </select>
                                    </div>
                                {renderValidation("sexo")}
                            </div>
                        </div>
                        )} 
                        <div className="linha-form"><div>Nome do beneficiário <span className="txt-vermelho">*</span></div><div><input type="text" maxLength="80" value={response.nomeBeneficiario ? response.nomeBeneficiario : nome} disabled={response.nomeBeneficiario} onChange={e => setNome(e.target.value)} /></div></div>
                        {renderValidation('nome')}
                        <div className="linha-form"><div>Telefone 1 <span className="txt-vermelho">*</span></div><div> <Cleave type="tel" onChange={e => setTelefone1(e.target.value)} options={{ blocks: [2, 4, 5], delimiter: ' ', numericOnly: true }} /></div></div>
                        <div className="linha-form"><div>Telefone 2</div><div> <Cleave type="tel" onChange={e => setTelefone2(e.target.value)} options={{ blocks: [2, 4, 5], delimiter: ' ', numericOnly: true }} /></div></div>
                        {renderValidation('telefone')}
                        <div className="linha-form"><div>Data de realização do procedimento </div><div><Cleave type={'ontouchstart' in document.documentElement ? "tel" : "text"} options={{ date: true, datePattern: ['d', 'm', 'Y'] }} onChange={e => setDataRealizacao(e.target.value)} /></div></div>
                        {renderValidation('dataRealizacao')}
                        <div className="linha-form"><div>Local de realização do procedimento <span className="txt-vermelho">*</span></div><div><input type="text" maxLength="90" value={local} onChange={e => setLocal(e.target.value)} /></div></div>
                        {renderValidation('local')}
                        <div className="linha-form"><div>Tipo de procedimento <span className="txt-vermelho">*</span></div><div>
                            <select onChange={e => setTipaut(e.target.value)}>
                                <option value=''>Selecione</option>
                                <option value='2'>Consultas | Exames | Terapias</option>
                                <option value='1'>Cirurgias | Internações | Medicamentos</option>
                            </select>
                            </div></div>
                        {renderValidation('tipaut')}
                        <div className="linha-form"><div>E-mail <span className="txt-vermelho">*</span></div><div><input type="email" maxLength="70" value={email} onChange={e => setEmail(e.target.value)} /></div></div>
                        {renderValidation('email')}
                        <div className="linha-form"><div>Confirme seu e-mail <span className="txt-vermelho">*</span></div><div><input type="email" maxLength="70" value={emailConf} onChange={e => setEmailConf(e.target.value)} /></div></div>
                        {renderValidation('emailConf')}
                        {renderFiles()}
                        {renderUpload()}
                        {renderValidation('files')}
                        {renderError()}
                        {renderValidation("solicitacao")}
                        {renderSuccess()}
                        {loadingForm ?
                            <div className="lds-ring"><div></div><div></div><div></div><div></div></div> : null}
                        {!!!loadingForm && !!!protocolo ?
                            <div className=""><button className="btn" onClick={() => onSendForm()}>Enviar solicitação</button></div>
                            : null}
                    </div>
                </div>
            </div>
            {renderImagePreview()}
        </section>
    );
};
